// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./variables.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./flex.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./theme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./special-theme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./base/tooltip.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./base/button.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./base/section.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./structural/card.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./structural/logo-container.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./base/badge.css";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./base/animated-line.css";
import ___CSS_LOADER_AT_RULE_IMPORT_11___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./base/stamp.css";
import ___CSS_LOADER_AT_RULE_IMPORT_12___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./base/background-manager.css";
import ___CSS_LOADER_AT_RULE_IMPORT_13___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./base/footer-content.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_11___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_12___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  -webkit-font-smoothing: inherit;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;
}

html {
  font-size: 15px;
  font-family: "Inter", sans-serif;
}

html,
body,
main {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

h1,
h2,
p {
  margin: 0;
}

h1,
h2 {
  font-weight: 500;
}

h1 {
  font-size: var(--font-size-h1);
}

h2 {
  font-size: var(--font-size-h2);
}

p {
  font-family: "Inter";
  line-height: 1.5;
}

main {
  position: relative;
  min-height: 100vh;
  width: auto;
  gap: var(--spacing-extra-large);
  height: -moz-min-content;
  height: min-content;
  padding: var(--spacing-large) 0px;
  overflow: hidden;
}

footer {
  font-size: var(--font-size-small);
  padding-bottom: var(--spacing-meduim);
  text-wrap: balance;
  font-weight: 300;
}

@media (max-width: 768px) {
  * {
    -webkit-tap-highlight-color: transparent;
  }
  html {
    font-size: 16px;
  }
  p {
    line-height: 1.4;
  }
}

@media (min-width: 1200px) {
  html {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/main.css"],"names":[],"mappings":"AAgBA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B;;mBAEiB;AACnB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;;;EAGE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;;EAGE,SAAS;AACX;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,+BAA+B;EAC/B,wBAAmB;EAAnB,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n@import url(\"./variables.css\");\n@import url(\"./flex.css\");\n@import url(\"./theme.css\");\n@import url(\"./special-theme.css\");\n@import url(\"./base/tooltip.css\");\n@import url(\"./base/button.css\");\n@import url(\"./base/section.css\");\n@import url(\"./structural/card.css\");\n@import url(\"./structural/logo-container.css\");\n@import url(\"./base/badge.css\");\n@import url(\"./base/animated-line.css\");\n@import url(\"./base/stamp.css\");\n@import url(\"./base/background-manager.css\");\n@import url(\"./base/footer-content.css\");\n\n* {\n  box-sizing: border-box;\n  -webkit-font-smoothing: inherit;\n  transition:\n    background-color 0.3s ease,\n    color 0.3s ease;\n}\n\nhtml {\n  font-size: 15px;\n  font-family: \"Inter\", sans-serif;\n}\n\nhtml,\nbody,\nmain {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nh1,\nh2,\np {\n  margin: 0;\n}\n\nh1,\nh2 {\n  font-weight: 500;\n}\n\nh1 {\n  font-size: var(--font-size-h1);\n}\n\nh2 {\n  font-size: var(--font-size-h2);\n}\n\np {\n  font-family: \"Inter\";\n  line-height: 1.5;\n}\n\nmain {\n  position: relative;\n  min-height: 100vh;\n  width: auto;\n  gap: var(--spacing-extra-large);\n  height: min-content;\n  padding: var(--spacing-large) 0px;\n  overflow: hidden;\n}\n\nfooter {\n  font-size: var(--font-size-small);\n  padding-bottom: var(--spacing-meduim);\n  text-wrap: balance;\n  font-weight: 300;\n}\n\n@media (max-width: 768px) {\n  * {\n    -webkit-tap-highlight-color: transparent;\n  }\n  html {\n    font-size: 16px;\n  }\n  p {\n    line-height: 1.4;\n  }\n}\n\n@media (min-width: 1200px) {\n  html {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
